import LookUpModel from "stores/lookup/models/LookUpModel";

export default class ProdottoLightModel extends LookUpModel {
    constructor(data: Partial<ProdottoLightModel>) {
        super(data);

        this.update(data);
    }
}
